export default __webpack_public_path__ + "static/media/hubIcon.0d2c379f.svg";